import { Button, Checkbox, FormControl, FormControlLabel, FormGroup, FormHelperText, MenuItem, Pagination, Radio, RadioGroup, Select, SelectChangeEvent, TextField } from "@mui/material";
import "../Common/css/styles.css";
import Card from "../Components/Card";
import text from "../Assets/Text/Text.json";
import { useNavigate } from "react-router";
import { useEffect, useState } from "react";
import PrimaryInputField from "src/Components/InputFields";
import CustomAlert from "src/Components/Alerts";
import Spinner from "src/Components/Spinner";
import { DatePicker, LocalizationProvider } from "@mui/x-date-pickers"
import { AdapterDayjs } from "@mui/x-date-pickers/AdapterDayjs"
import dayjs, { Dayjs } from "dayjs";
import AuthRegister from "src/Layouts/AuthRegister";
import { StudentDetails } from "src/Interfaces/auth";
import { getStreams, register } from "src/Services/auth_api";
import React from "react";


const Registration = () => {

    const navigate = useNavigate();

    const [loading, setLoading] = useState(false);
    const [alertOpen, setAlertOpen] = useState(false);
    const [alertDescription, setAlertDescription] = useState("");
    const [alertType, setAlertType] = useState<"success" | "error" | "warning">("success")

    const [fullName, setFullName] = useState('');
    const [address, setAddress] = useState('');
    const [email, setEmail] = useState('');
    const [password, setPassword] = useState('');
    const [confirmPassword, setConfirmPassword] = useState('');
    const [conatctNo, setContactNo] = useState("")
    const [parentConatctNo, setParentContactNo] = useState("")
    const [nicNo, setNicNo] = useState("")
    const [dob, setDob] = useState<Dayjs | null>(null);
    const [gender, setGender] = useState<string>("");

    const [option, setOption] = useState("default")
    const [selectedStream, setSelectedStream] = useState("default");
    const [selectedSubjects, setSelectedSubjects] = useState<string[]>([]);
    const [scholarshipCode, setScholarshipCode] = useState("");
    const [selectedCertificates, setSelectedCertificates] = useState<string[]>([]);

    const [options, setOptions] = useState<any[]>([])

    const [step, setStep] = useState(1);

    let selectedProgramData: any = options.find((opt: any) => opt.label === option);
    let selectedStreamData = selectedProgramData?.streams.find((opt: any) => opt.stream === selectedStream);

    useEffect(() => {
        setLoading(true);
        clear()
        selectedProgramData = options.find((opt: any) => opt.label === option);
        selectedStreamData = selectedProgramData?.streams.find((opt: any) => opt.stream === selectedStream);
        getStreamsDetails()
    }, []);

    const clear = () => {
        setFullName("")
    }

    const showAlert = (description: string, type: "success" | "error" | "warning") => {
        setAlertDescription(description);
        setAlertType(type);
        setAlertOpen(true);
    };

    const getStreamsDetails = async () => {
        try {
            const response = await getStreams();
            setOptions(response.data.options[0])
        } catch (error) {
            //console.log(error);
        }
    }

    const handleCertificateChange = (certificate: string) => {
        setSelectedCertificates((prev) =>
            prev.includes(certificate)
                ? prev.filter((cert) => cert !== certificate) // Remove if already selected
                : [...prev, certificate] // Add if not selected
        );
    };

    const handleGenderChange = (event: React.ChangeEvent<HTMLInputElement>) => {
        setGender(event.target.value);
    };

    const handleOptionOnChange = (event: SelectChangeEvent<string>) => {
        setOption(event.target.value);
        selectedProgramData = options.find((opt: any) => opt.value === option);
        setSelectedStream("default");
        setScholarshipCode("")
        setSelectedSubjects([])
        setSelectedCertificates([])
    };

    const handleStreamChange = (event: SelectChangeEvent<string>) => {
        setSelectedStream(event.target.value);
        selectedStreamData = selectedProgramData?.streams.find((opt: any) => opt.id === selectedStream);
        setSelectedSubjects([])
        setSelectedCertificates([])
    };

    const handleSubjectChange = (subId: string) => {
        setSelectedSubjects((prev) =>
            prev.includes(subId) ? prev.filter((id) => id !== subId) : [...prev, subId]
        );
    };

    const validateEmail = (email: string): boolean => {
        const emailRegex = /^[a-zA-Z0-9._%+-]+@[a-zA-Z0-9.-]+\.[a-zA-Z]{2,}$/;
        return emailRegex.test(email);
    };


    const handleStep = (value: any) => {

        if (value === 2) {
            if (fullName === "") {
                showAlert("Missing Full Name", "error")
                return
            }

            if (email === "") {
                showAlert("Missing Email", "error")
                return
            }

            if (password === "") {
                showAlert("Missing Password", "error")
                return
            }

            if (confirmPassword === "") {
                showAlert("Missing Confirm Password", "error")
                return
            }

            if (address === "") {
                showAlert("Missing Address", "error")
                return
            }

            if (nicNo === "") {
                showAlert("Missing NIC No", "error")
                return
            }

            if (nicNo.length > 12) {
                showAlert("Invalid NIC No", "error")
                return
            }

            if (dob === null) {
                showAlert("Missing Date of Birth", "error")
                return
            }

            if (conatctNo === "") {
                showAlert("Missing Contact No", "error")
                return
            }

            if (parentConatctNo === "") {
                showAlert("Missing Parent Contact No", "error")
                return
            }

            if (gender === "") {
                showAlert("Missing Gender", "error")
                return
            }

            if (!validateEmail(email)) {
                showAlert("Invalid Email", "error");
                return;
            }

            if (password !== confirmPassword) {
                showAlert("Password and Confirm Password Mismatch", "error")
                return
            }

            if (conatctNo.length !== 10 || conatctNo.startsWith("0") === false) {
                showAlert("Invalid Contact Number", "error")
                return
            }

            if (parentConatctNo.length !== 10 || parentConatctNo.startsWith("0") === false) {
                showAlert("Invalid Parent Contact Number", "error")
                return
            }

            setStep(value)
        } else {
            setStep(value)
        }
    }

    const handleSave = async () => {

        if (option === "default") {
            showAlert("Missing Programme", "error")
            return
        }

        if (selectedStream === "default") {
            showAlert("Missing Stream", "error")
            return
        }

        if (option === "Fast track A/L") {
            if (selectedStream === "Arts Stream" || selectedStream === "Commerce Stream" || selectedStream === "Technology Stream") {
                if (selectedSubjects.length === 0) {
                    showAlert("Please Select Minimum One Subject", "error")
                    return
                }
            }
        }

        const body: StudentDetails = {
            encodedPassword: password,
            email: email,
            address: address,
            fullName: fullName,
            programme: option,
            stream: selectedStream,
            contactNumber: Number(conatctNo),
            parentContactNumber: Number(parentConatctNo),
            dob: dayjs(dob).format("YYYY-MM-DD"),
            gender: gender,
            studentNic: nicNo,
            subjects: selectedSubjects,
            scholarshipCode: scholarshipCode,
            freeCourses: selectedCertificates
        }

        setLoading(true)
        try {
            const response = await register(body);
            if (response.data === "User registration successful.") {
                showAlert("Registration Successfull", "success")
                setTimeout(() => {
                    navigate("/")
                }, 2000);
            }
        } catch (error: any) {
            showAlert(error.response.data.message, "error")
        }

        /*try {
            createPaymentRequest(1000.00, "", "", "", "")
        } catch (error) {
            //console.log(error);
        }*/
    }

    return (
        <AuthRegister>
            <Card>
                <div className="login-main-outer1">
                    <CustomAlert
                        open={alertOpen}
                        onClose={() => setAlertOpen(false)}
                        description={alertDescription}
                        type={alertType}
                        timeout={3000}
                    />
                    <Spinner isLoading={loading} />
                    <div className="login-head-outer-title">
                        <span className="login-header-text">{text.registrationPage.header}</span>
                    </div>

                    {step === 1 && (
                        <div className="login-main-outer2">
                            <div className="login-main-inner lgmi-left">
                                <>
                                    <div className="login-head-outer mt">
                                        <PrimaryInputField
                                            placeholder="Enter Full Name"
                                            helperText={text.registrationPage.fullNameLabel}
                                            value={fullName}
                                            type="text"
                                            disabled={false}
                                            width="100ch"
                                            size="small"
                                            onChange={(e: any) => setFullName(e.target.value)}
                                        />
                                    </div>
                                    <div className="login-head-outer">
                                        <PrimaryInputField
                                            placeholder="Enter Email"
                                            helperText={text.registrationPage.emailLabel}
                                            value={email}
                                            type="text"
                                            disabled={false}
                                            width="400ch"
                                            size="small"
                                            onChange={(e: any) => setEmail(e.target.value)}
                                        />
                                    </div>
                                    <div className="login-head-outer lho">
                                        <div className="login-inner1">
                                            <PrimaryInputField
                                                placeholder="Enter Password"
                                                helperText={text.registrationPage.passwordLabel}
                                                value={password}
                                                type="password"
                                                disabled={false}
                                                width="400ch"
                                                size="small"
                                                onChange={(e: any) => setPassword(e.target.value)}
                                            />
                                        </div>
                                        <div className="login-inner1 inner2">
                                            <PrimaryInputField
                                                placeholder="Enter Password"
                                                helperText={text.registrationPage.confirmPasswordLabel}
                                                value={confirmPassword}
                                                type="password"
                                                disabled={false}
                                                width="400ch"
                                                size="small"
                                                onChange={(e: any) => setConfirmPassword(e.target.value)}
                                            />
                                        </div>
                                    </div>
                                    <div className="login-head-outer">
                                        <PrimaryInputField
                                            placeholder="Enter Address"
                                            helperText={text.registrationPage.addressLabel}
                                            value={address}
                                            type="text"
                                            disabled={false}
                                            width="400ch"
                                            size="small"
                                            onChange={(e: any) => setAddress(e.target.value)}
                                        />
                                    </div>
                                    <div className="login-head-outer2 no-display">
                                    </div>
                                </>
                            </div>

                            <div className="lmi"></div>

                            <div className="login-main-inner">

                                <>
                                    <div className="login-head-outer mt lho1">
                                        <PrimaryInputField
                                            placeholder="Enter NIC"
                                            helperText={text.registrationPage.nicNoLabel}
                                            value={nicNo}
                                            type="text"
                                            disabled={false}
                                            width="400ch"
                                            size="small"
                                            onChange={(e: any) => setNicNo(e.target.value)}
                                        />
                                    </div>
                                    <div className="login-head-outer">
                                        <FormControl sx={{ mt: 0.5, mb: 0.5, ml: 1, mr: 1, width: "400ch" }} variant="outlined">
                                            <FormHelperText sx={{ ml: 0.5, mb: 1, fontSize: '14px', color: '#ffffff' }}>
                                                {text.registrationPage.dobLabel}
                                            </FormHelperText>
                                            <LocalizationProvider dateAdapter={AdapterDayjs}>
                                                <DatePicker
                                                    label=""
                                                    value={dob}
                                                    onChange={(newValue: any) => setDob(newValue)}
                                                    renderInput={(params) => <TextField {...params} />}
                                                />
                                            </LocalizationProvider>
                                        </FormControl>
                                    </div>
                                    <div className="login-head-outer lho">
                                        <div className="login-inner1">
                                            <PrimaryInputField
                                                placeholder="07X XXX XXXX"
                                                helperText={text.registrationPage.contactNoLabel}
                                                value={conatctNo}
                                                type="number"
                                                disabled={false}
                                                width="400ch"
                                                size="small"
                                                maxDigits={10}
                                                onChange={(e: any) => setContactNo(e.target.value)}
                                            />
                                        </div>
                                        <div className="login-inner1 inner2">
                                            <PrimaryInputField
                                                placeholder="07X XXX XXXX"
                                                helperText={text.registrationPage.parentContactNoLabel}
                                                value={parentConatctNo}
                                                type="number"
                                                disabled={false}
                                                width="400ch"
                                                size="small"
                                                maxDigits={10}
                                                onChange={(e: any) => setParentContactNo(e.target.value)}
                                            />
                                        </div>
                                    </div>

                                    <div className="login-head-outer">
                                        <FormControl sx={{ m: 1, width: "200ch" }} variant="outlined">
                                            <FormHelperText sx={{ ml: 0.5, mb: 0, fontSize: '14px', color: '#ffffffff' }}>
                                                {text.registrationPage.genderLabel}
                                            </FormHelperText>
                                            <RadioGroup
                                                row
                                                value={gender}
                                                onChange={handleGenderChange}
                                                aria-labelledby="demo-row-radio-buttons-group-label"
                                                name="row-radio-buttons-group"
                                                sx={{
                                                    display: "flex",
                                                    justifyContent: "center",
                                                    alignItems: "center",
                                                    width: "100%"
                                                }}
                                            >
                                                <FormControlLabel
                                                    value="female"
                                                    control={
                                                        <Radio
                                                            sx={{
                                                                color: "#fff",
                                                                "&.Mui-checked": { color: "#FFEC00" } // Selected color
                                                            }}
                                                        />
                                                    }
                                                    label={<span style={{ color: "#fff" }}>{text.registrationPage.female}</span>}
                                                    sx={{ width: "50%" }}
                                                />
                                                <FormControlLabel
                                                    value="male"
                                                    control={
                                                        <Radio
                                                            sx={{
                                                                color: "#fff",
                                                                "&.Mui-checked": { color: "#FFEC00" }
                                                            }}
                                                        />
                                                    }
                                                    label={<span style={{ color: "#fff" }}>{text.registrationPage.male}</span>}
                                                />
                                            </RadioGroup>
                                        </FormControl>
                                    </div>
                                    <div className="login-head-outer2 no-display">
                                    </div>
                                </>
                            </div>
                        </div>
                    )}

                    {step === 2 && (
                        <div className="login-main-outer2">
                            <div className="login-main-inner lgmi-left">

                                <>
                                    <div className="login-head-outer mt">
                                        <FormControl sx={{ m: 1, width: "400ch" }} variant="outlined" size="small">
                                            <FormHelperText sx={{ ml: 0.5, mb: 1, fontSize: '14px', color: '#ffffffff' }}>
                                                {text.registrationPage.selectProgramLabel}
                                            </FormHelperText>

                                            <Select
                                                value={option}
                                                onChange={handleOptionOnChange}
                                                disabled={false}
                                                MenuProps={{
                                                    PaperProps: {
                                                        sx: {
                                                            backgroundColor: '#b2bec3',
                                                            color: 'black',
                                                        },
                                                    },
                                                }}
                                                sx={{
                                                    backgroundColor: '#5F616E',
                                                    borderRadius: '8px',
                                                    color: 'white',
                                                    '& fieldset': {
                                                        border: 'none',
                                                    },
                                                }}
                                            >
                                                <MenuItem value={"default"} disabled>{text.registrationPage.selectProgramLabel}</MenuItem>
                                                {options.map((option: any, index) => (
                                                    <MenuItem key={index} value={option.label}>
                                                        {option.label}
                                                    </MenuItem>
                                                ))}
                                            </Select>
                                        </FormControl>
                                    </div>
                                    <div className="login-head-outer">
                                        <FormControl sx={{ m: 1, width: "400ch" }} variant="outlined" size="small">
                                            <FormHelperText sx={{ ml: 0.5, mb: 1, fontSize: '14px', color: '#ffffffff' }}>
                                                {text.registrationPage.selectStreamLabel}
                                            </FormHelperText>

                                            <Select
                                                value={selectedStream}
                                                onChange={handleStreamChange}
                                                disabled={false}
                                                MenuProps={{
                                                    PaperProps: {
                                                        sx: {
                                                            backgroundColor: '#b2bec3',
                                                            color: 'black',
                                                        },
                                                    },
                                                }}
                                                sx={{
                                                    backgroundColor: '#5F616E',
                                                    borderRadius: '8px',
                                                    color: 'white',
                                                    '& fieldset': {
                                                        border: 'none',
                                                    },
                                                }}
                                            >
                                                <MenuItem value={"default"} disabled>{text.registrationPage.selectStreamLabel}</MenuItem>
                                                {selectedProgramData?.streams.map((option: any, index: any) => (
                                                    <MenuItem key={index} value={option.stream}>
                                                        {option.stream}
                                                    </MenuItem>
                                                ))}
                                            </Select>
                                        </FormControl>
                                    </div>
                                    <div className="login-head-outer3">
                                        {selectedStream && selectedStreamData?.subjects?.length ? (
                                            <FormGroup>
                                                {selectedStreamData.subjects.map((subject: any) => (
                                                    <FormControlLabel
                                                        key={subject.subject}
                                                        control={
                                                            <Checkbox
                                                                checked={selectedSubjects.includes(subject.subject)}
                                                                onChange={() => handleSubjectChange(subject.subject)}
                                                                sx={{
                                                                    color: "#FFD700",
                                                                    "&.Mui-checked": { color: "#FFD700" }
                                                                }}
                                                            />
                                                        }
                                                        label={<span style={{ color: "white" }}>{subject.subject}</span>}
                                                    />
                                                ))}
                                            </FormGroup>
                                        ) : null}

                                    </div>

                                    <div className="login-head-outer2 space no-display">
                                    </div>
                                </>
                            </div>

                            <div className="lmi"></div>

                            <div className="login-main-inner">

                                <>
                                    <>
                                        <div className="login-head-outer mt lho1">
                                            <PrimaryInputField
                                                placeholder="Enter Scholarship Code"
                                                helperText={text.registrationPage.scholarshipLabel}
                                                value={scholarshipCode}
                                                type="text"
                                                disabled={!(option !== "Fast track A/L")}
                                                width="100ch"
                                                size="small"
                                                onChange={(e: any) => setScholarshipCode(e.target.value)}
                                            />
                                        </div>
                                    </>

                                    <div className="login-header-outer">
                                        <FormControl sx={{ mt: 1, ml: 1, width: "auto" }} variant="outlined" size="small">
                                            <FormHelperText sx={{ ml: 0.5, mb: 1, fontSize: '14px', color: '#ffffffff' }}>
                                                {text.registrationPage.freeOfferLabel}
                                            </FormHelperText>
                                        </FormControl>

                                        {(selectedStream !== "Arts Stream" && selectedStream !== "Commerce Stream" && selectedStream !== "Technology Stream") && (
                                            <div className="center-text">
                                                <p className="help-text">{text.registrationPage.noCoursesLabel}</p>
                                            </div>
                                        )}
                                    </div>

                                    {selectedStream === "Arts Stream" && (
                                        <div className="login-head-outer3">
                                            <FormControlLabel
                                                control={
                                                    <Checkbox
                                                        sx={{
                                                            color: "#FFD700",
                                                            "&.Mui-checked": { color: "#FFD700" }
                                                        }}
                                                        checked={selectedCertificates.includes("English Certificate")}
                                                        onChange={() => handleCertificateChange("English Certificate")}
                                                    />
                                                }
                                                label={
                                                    <span style={{ color: "white" }}>
                                                        {text.registrationPage.englishCertificateLabel}
                                                    </span>
                                                }
                                            />
                                            <FormControlLabel
                                                control={
                                                    <Checkbox
                                                        sx={{
                                                            color: "#FFD700",
                                                            "&.Mui-checked": { color: "#FFD700" }
                                                        }}
                                                        checked={selectedCertificates.includes("IT Certificate")}
                                                        onChange={() => handleCertificateChange("IT Certificate")}
                                                    />
                                                }
                                                label={
                                                    <span style={{ color: "white" }}>
                                                        {text.registrationPage.itCertificateLabel}
                                                    </span>
                                                }
                                            />
                                        </div>
                                    )}

                                    {(selectedStream === "Commerce Stream" || selectedStream === "Technology Stream") && (
                                        <div className="login-head-outer3">
                                            <FormControlLabel
                                                control={
                                                    <Checkbox
                                                        sx={{
                                                            color: "#FFD700",
                                                            "&.Mui-checked": { color: "#FFD700" }
                                                        }}
                                                        checked={selectedCertificates.includes("English Diploma")}
                                                        onChange={() => handleCertificateChange("English Diploma")}
                                                    />
                                                }
                                                label={<span style={{ color: "white" }}>{text.registrationPage.englishDiplomaLabel}</span>}
                                            />
                                            <FormControlLabel
                                                control={
                                                    <Checkbox
                                                        sx={{
                                                            color: "#FFD700",
                                                            "&.Mui-checked": { color: "#FFD700" }
                                                        }}
                                                        checked={selectedCertificates.includes("IT Diploma")}
                                                        onChange={() => handleCertificateChange("IT Diploma")}
                                                    />
                                                }
                                                label={<span style={{ color: "white" }}>{text.registrationPage.itDiplomaLabel}</span>}
                                            />
                                            <FormControlLabel
                                                control={
                                                    <Checkbox
                                                        sx={{
                                                            color: "#FFD700",
                                                            "&.Mui-checked": { color: "#FFD700" }
                                                        }}
                                                        checked={selectedCertificates.includes("HRM Diploma")}
                                                        onChange={() => handleCertificateChange("HRM Diploma")}
                                                    />
                                                }
                                                label={<span style={{ color: "white" }}>{text.registrationPage.hrmDiplomaLabel}</span>}
                                            />
                                            <FormControlLabel
                                                control={
                                                    <Checkbox
                                                        sx={{
                                                            color: "#FFD700",
                                                            "&.Mui-checked": { color: "#FFD700" }
                                                        }}
                                                        checked={selectedCertificates.includes("Marketing Diploma")}
                                                        onChange={() => handleCertificateChange("Marketing Diploma")}
                                                    />
                                                }
                                                label={<span style={{ color: "white" }}>{text.registrationPage.marketingDiplomaLabel}</span>}
                                            />
                                        </div>
                                    )}

                                    {selectedStream === "Arts Stream" && (
                                        <div className="art-space"></div>
                                    )}

                                    {selectedStream === "Commerce Stream" && (
                                        <div className="commerce-space"></div>
                                    )}

                                    {selectedStream === "Technology Stream" && (
                                        <div className="tech-space"></div>
                                    )}

                                    <div className="login-head-outer right">
                                        <Button className="primary-btn mr" variant="contained" onClick={handleSave}>
                                            {text.registrationPage.registrationBtn}
                                        </Button>
                                    </div>
                                    <div className="login-head-outer2">
                                    </div>
                                </>
                            </div>
                        </div>
                    )}

                    <div className="login-head-outer" style={{ width: "auto", display: "flex", justifyContent: "space-between", marginTop: "0px", paddingLeft: "10px", paddingRight: "10px" }}>
                        <a className="backBtn" href="/">{text.registrationPage.backLabel}</a>
                        <Pagination
                            count={2}
                            page={step}
                            onChange={(event, value) => handleStep(value)}
                            sx={{
                                '& .MuiPaginationItem-root': {
                                    backgroundColor: '#5F616E',
                                    color: 'black',
                                    fontWeight: 'bold',
                                    '&:hover': {
                                        backgroundColor: '#E6D700',
                                    },
                                },
                                '& .Mui-selected': {
                                    backgroundColor: '#FFEC00 !important',
                                    color: 'black !important',
                                }
                            }}
                        />
                    </div>
                </div>
            </Card>
        </AuthRegister>
    );
};

export default Registration;
